module.exports = __webpack_public_path__ + "static/media/fly0245.0878963c.webp";